import axios, { AxiosRequestConfig } from 'axios'
import { getEmployeeExperienceBaseUrl } from './employee-experience'

const CREDENTIALS_KEY = 'admin-token'

// Cognito idToken from persisted @hixme/auth-ui credentials (as the Apollo client does).
export const getEpsAuthToken = (): string => {
  try {
    const raw = localStorage.getItem(CREDENTIALS_KEY)
    if (!raw) return ''
    return JSON.parse(raw)?.idToken || ''
  } catch {
    return ''
  }
}

export const withEpsAuth = (config: AxiosRequestConfig): AxiosRequestConfig => {
  config.headers = config.headers || {}
  config.headers.Authorization = getEpsAuthToken()
  return config
}

// EPS calls that must carry the signed access_token cookie: employee-experience host
// (which mints the cookie) + withCredentials so the browser sends it.
export const epsClient = axios.create({
  baseURL: getEmployeeExperienceBaseUrl(),
  withCredentials: true,
})

epsClient.interceptors.request.use(withEpsAuth)
